// extracted by mini-css-extract-plugin
export var blink = "LogInOutButton-module--blink--50dc1";
export var button = "LogInOutButton-module--button--af40a";
export var gradient = "LogInOutButton-module--gradient--20273";
export var spin = "LogInOutButton-module--spin--b0e6e";